<template>
  <div>
    <div v-if="!isLoading">
      <base-car-configuration />
      <wltp-values />
      <exterior-car-configuration />
      <interior-car-configuration />
      <factory-options-car-configuration />
      <importer-options-car-configuration />
      <bpm-car-configuration />
    </div>
    <loader v-if="isLoading" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import BaseCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/BaseCarConfiguration.vue'
import ExteriorCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/ExteriorCarConfiguration.vue'
import BpmCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/BpmCarConfiguration.vue'
import FactoryOptionsCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/FactoryOptionsCarConfiguration.vue'
import ImporterOptionsCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/ImporterOptionsCarConfiguration.vue'
import InteriorCarConfiguration from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/InteriorCarConfiguration.vue'
import WltpValues from '@/components/changeOrder/presentational/organisms/changeOrderConfiguration/WltpValues.vue'

export default {
  components: {
    WltpValues,
    InteriorCarConfiguration,
    BaseCarConfiguration,
    FactoryOptionsCarConfiguration,
    ImporterOptionsCarConfiguration,
    BpmCarConfiguration,
    ExteriorCarConfiguration,
    Loader,
  },
  provide() {
    return {
      enableNoBpm: this.enableNoBpm,
    }
  },
  props: {
    enableNoBpm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      editableConfiguration: null,
      komNumber: '',
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({ changeOrder: 'changeOrder/get' }),
  },
  watch: {
    changeOrder: {
      handler(newValue) {
        this.isLoading = !newValue
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row:not(.header)) {
  border-bottom: 0;
}
:deep(.price-incl) {
  font-weight: 700;
}
:deep(.edit-dialog) {
  font-weight: 700;
  grid-area: edit-dialog;
}

.quote-block {
  margin-bottom: 0;
}
</style>
